import * as React from 'react';

import { HandleUserSettingsRequire } from './components/HandleUserSettingsRequire';
import { HandleUserSettingsUpdate } from './components/HandleUserSettingsUpdate';

export const HandleUserSettings: React.FC = () => {
  return (
    <>
      <HandleUserSettingsRequire />
      <HandleUserSettingsUpdate />
    </>
  );
};
